import styled from 'styled-components';

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
  padding-bottom: calc(8px + var(--ion-safe-area-bottom, 0px));
`;

export default FormButtonContainer;
